import { URL_REPLACEMENT } from '$const';
import { get, remove } from '~services/api/methods';

export async function fetchDocumentIsOpen(documentId: number, clientId: number) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/document/is_open/${documentId}/${clientId}`;
  const response = await get(requestUrl);
  return response;
}
export async function deleteDocument(documentId: number, clientId: number) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/document/delete/${documentId}/${clientId}`;
  const response = await remove(requestUrl);
  return response;
}
